/*
 * Copyright (c) 2018 Infowijs.
 * Created by Thomas Schoffelen.
 */

window.calendarData = {}

function initCalendar () {
  $('.calendar[data-src]').each(function () {
    loadCalendar($(this))
  })
}

function loadCalendar ($el) {
  const src = $el.data('src')

  $el.find('.calendar-url').click(function () {
    $(this).select()
  })

  $el.find('.calendar-add-btn').click(function (e) {
    e.preventDefault()
    $el.find('.calendar-add-modal').show()
  })

  $el.find('.calendar-add-modal-close').click(function () {
    $el.find('.calendar-add-modal').hide()
  })

  if (src in window.calendarData) {
    renderCalendar($el, window.calendarData[src])
    return
  }

  $.getJSON('/calendar/values?q=' + encodeURIComponent(src), function (data) {
    window.calendarData[src] = data
    renderCalendar($el, data)
  })
}

function getCurrentMonth ($el, data) {
  const current = $el.data('current')
  if (current === undefined) {
    return data.current
  }

  return parseInt(current)
}

function renderCalendar ($el, data) {
  if (!data || data.error || !data.sections) {
    return // TODO: show error to user
  }

  const current = getCurrentMonth($el, data)

  const ds = data.sections[current]
  const items = ds[1]

  $el.find('.calendar-month').first().text(ds[0])

  let html = ''
  for (let x in items) {
    if (!items.hasOwnProperty(x)) {
      continue
    }
    const attr = items[x][0]
    if (items[x][1]) {
      html += '<div class="calendar-today" title="Vandaag"></div>'
    }
    html += '<div class="calendar-event">Datum<div class="calendar-value">' + attr.Datum + '</div>Titel<div class="calendar-value">' + attr.Titel + '</div></div>'
  }

  const $content = $el.find('.calendar-content')
  $content.html(html)
  const today = $el.find('.calendar-today').first()
  if (today.length) {
    $content.animate({
      scrollTop: Math.max(0, today.position().top - 100)
    }, 200)
  }
}

function calNext (id) {
  const $el = $('#' + id)
  const data = window.calendarData[$el.data('src')]
  let current = getCurrentMonth($el, data)
  if (current + 1 < data.sections.length) {
    current++
  }
  $el.data('current', current)
  renderCalendar($el, data)
}

function calPrev (id) {
  const $el = $('#' + id)
  const data = window.calendarData[$el.data('src')]
  let current = getCurrentMonth($el, data)
  if (current > 1) {
    current--
  }
  $el.data('current', current)
  renderCalendar($el, data)
}

initCalendar()
$(document).on('pjax:end', initCalendar)
